import { useState, useEffect } from 'react';
import './AlpCheckbox.scss';

interface AlpCheckboxProps {
  id: any;
  selectedId: any;
  label?: String;
  color: 'green' | 'blue' | 'red' | 'purple' | 'yellow' | 'brown' | 'skyblue';
  onToggle(id: String): void;
  blackLabel?: boolean;
}

function AlpCheckbox({ id, selectedId, label, color, onToggle, blackLabel = false }: AlpCheckboxProps) {
  const [checkboxClass, setCheckboxclass] = useState('');

  useEffect(() => {
    if (id === selectedId || selectedId?.includes(id)) {
      setCheckboxclass('custom-checkbox box-center clickable selected');
    } else {
      setCheckboxclass('custom-checkbox box-center clickable');
    }
  }, [selectedId]);

  return (
    <div className={`alp-checkbox-wrapper flex flex-center ${color}-checkbox`}>
      <div className={checkboxClass} onClick={() => onToggle(id)}>
        <i className="icon icon-check" />
      </div>
      {label && <label className={blackLabel ? 'black-label' : ''}>{label}</label>}
    </div>
  );
}

export default AlpCheckbox;